<script>
    import { time_string } from "../util/util";

    export let status;
</script>

<div class="server-status" class:online={status.online}>
    Server is {status.online ? "online" : "offline"}<br>
</div>
{#if !status.online}
<div class="status-downtime">
    Downtime: {time_string(status.downtime)}
</div>
{/if}

<style>
    .server-status {
        position: relative;
        width: fit-content;
        padding: 6px 18px 6px 50px;
        margin: 30px auto;
        border-radius: 4px;
        text-align: center;
        font-size: 18px;
        background-color: #eee;
        color: #777;
        font-weight: bold;
    }

    .server-status::before, .server-status.online::after {
        content: "";
        position: absolute;
        left: 22px;
        top: 12px;
        display: block;
        width: 12px;
        height: 12px;
        background-color: #bcbcbc;
        border-radius: 50%;
    }

    .server-status.online::after {
        animation: pulse 2s linear 0s infinite normal;
    }

    .server-status.online::before, .server-status.online::after {
        background-color: #62e710;
    }

    .server-status.online {
        background-color: #dffcc9;
        color: #417e15;
    }

    /* Status downtime substring */

    .status-downtime {
        text-align: center;
        color: #777;
    }


    @keyframes pulse {
        from {
            scale: 1;
            opacity: .7;
        }
        to {
            scale: 3;
            opacity: 0;
        }
    }
</style>